"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateRpcActions = exports.TemplateContentType = exports.TemplateTypeEnum = void 0;
var TemplateTypeEnum;
(function (TemplateTypeEnum) {
    TemplateTypeEnum["package_label"] = "package_label";
    TemplateTypeEnum["customer_notification_email"] = "customer_notification_email";
})(TemplateTypeEnum || (exports.TemplateTypeEnum = TemplateTypeEnum = {}));
var TemplateContentType;
(function (TemplateContentType) {
    TemplateContentType["label/zpl"] = "zpl";
    TemplateContentType["text/x-handlebars-template"] = "text/x-handlebars-template";
    TemplateContentType["text/html"] = "text/html";
})(TemplateContentType || (exports.TemplateContentType = TemplateContentType = {}));
var TemplateRpcActions;
(function (TemplateRpcActions) {
    TemplateRpcActions["GENERATE_LABEL"] = "generate:package_label";
    TemplateRpcActions["GET_TEMPLATE_DISPLAY_TYPE"] = "get:template_display_type";
})(TemplateRpcActions || (exports.TemplateRpcActions = TemplateRpcActions = {}));
//# sourceMappingURL=templates.js.map